import { queryClient } from "App";
import axios, { AxiosResponse, AxiosError } from "axios";
import {
  isSuccessorSessionResetEndpoint,
  resetSuccessorSessionTimer,
} from "utils/successorSessionTimer";

interface CustomError {
  message: string;
  data?: any;
  status?: number;
  headers?: any;
  request?: string;
}

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    const url = response.config?.url;
    if (isSuccessorSessionResetEndpoint(url)) {
      resetSuccessorSessionTimer();
    }
    return response;
  },
  async (error: AxiosError): Promise<any> => {
    let customError: CustomError = {
      message: error.message,
    };

    const url = error.config?.url;
    const normalizedUrl = url
      ? url.startsWith("/")
        ? url
        : `/${url}`
      : "";

    const isSuccessorLogout = normalizedUrl.startsWith("/successors/logout");

    if (
      error.response?.status === 401 &&
      error.config?.url !== "/users/me" &&
      !isSuccessorLogout
    ) {
      queryClient.clear();
      window.location.href = "/login";
    }

    if (error.response) {
      customError = {
        ...customError,
        data: error.response.data,
        status: error.response.status,
        headers: error.response.headers,
      };
    } else if (error.request) {
      customError = {
        ...customError,
        request: "Request was made but no response was received",
      };
    }

    return Promise.reject(customError);
  }
);

export default axiosInstance;
